module.exports = __webpack_public_path__ + "img/TrinApp-Documents-web.d1707988.png";